(function () {
  function refreshCartDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function setUpsellLoading(button, isLoading) {
    if (!button) {
      return;
    }

    if (isLoading) {
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    } else {
      button.removeAttribute('aria-busy');
      button.disabled = false;
    }
  }

  window.addRecommendedToCart = function (variantId, button) {
    setUpsellLoading(button, true);

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || 'Add to cart failed');
          }

          return data;
        });
      })
      .then(refreshCartDrawer)
      .catch(function (error) {
        console.error('Error adding product to cart:', error);
        setUpsellLoading(button, false);
      });
  };

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.upsell-action[data-variant-id]');

    if (button) {
      event.preventDefault();

      if (button.getAttribute('aria-busy') === 'true') {
        return;
      }

      window.addRecommendedToCart(parseInt(button.getAttribute('data-variant-id'), 10), button);
      return;
    }

    button = event.target.closest('.upsell-action[data-variant-select]');

    if (button) {
      event.preventDefault();

      if (button.getAttribute('aria-busy') === 'true') {
        return;
      }

      var productContainer = button.closest('.recommended-product');
      var selectElement = productContainer && productContainer.querySelector('.recommended-variant-select');

      if (selectElement) {
        window.addRecommendedToCart(parseInt(selectElement.value, 10), button);
      }
    }
  });

  document.addEventListener('click', function (event) {
    var checkoutButton = event.target.closest('cart-drawer [name="checkout"]');

    if (!checkoutButton || event.defaultPrevented) {
      return;
    }

    var cartDrawer = checkoutButton.closest('cart-drawer');
    var checkbox = cartDrawer && cartDrawer.querySelector('.terms-checkbox');

    if (checkbox && !checkbox.checked) {
      event.preventDefault();
      event.stopPropagation();
      alert(cartDrawer.getAttribute('data-terms-error') || 'Please agree to the terms and conditions.');
    }
  });

  function loadDynamicRecommendations(cartDrawer) {
    var productId = cartDrawer && cartDrawer.getAttribute('data-first-product-id');
    var recommendationsContainer = cartDrawer && cartDrawer.querySelector('#product-recommendations');

    if (!recommendationsContainer) {
      recommendationsContainer = document.createElement('div');
      recommendationsContainer.id = 'product-recommendations';

      var panel = document.createElement('div');
      panel.className = 'cart-drawer-recommendations';
      panel.innerHTML = '<h4>Handpicked for you</h4>';
      panel.appendChild(recommendationsContainer);

      var shell = cartDrawer.querySelector('.cart-drawer__shell');

      if (shell) {
        cartDrawer.insertBefore(panel, shell);
      } else {
        return;
      }
    }

    var staticCount = recommendationsContainer.querySelectorAll('.recommended-product').length;

    if (!productId) {
      return;
    }

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=12')
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (!data.products || data.products.length === 0) {
          return;
        }

        if (staticCount === 0 && data.products.length === 0) {
          return;
        }

        data.products.forEach(function (product) {
          if (recommendationsContainer.querySelector('[data-dynamic-product-id="' + product.id + '"]') || recommendationsContainer.querySelector('[data-product-id="' + product.id + '"]')) {
            return;
          }

          var card = document.createElement('div');
          card.className = 'recommended-product';
          card.setAttribute('data-dynamic-product-id', product.id);

          var price = (product.price / 100).toFixed(2);
          var formattedPrice = Shopify.formatMoney ? Shopify.formatMoney(product.price) : price;

          card.innerHTML =
            '<div class="image-container"><img src="' + product.featured_image + '" alt="' + product.title.replace(/"/g, '&quot;') + '"></div>' +
            '<p class="product-title">' + product.title + '</p>' +
            '<p>' + formattedPrice + '</p>';

          if (product.variants.length === 1) {
            var singleButton = document.createElement('button');
            singleButton.type = 'button';
            singleButton.className = 'button button--sm button--subdued upsell-action';
            singleButton.setAttribute('data-variant-id', product.variants[0].id);
            singleButton.textContent = '+ Add';
            card.appendChild(singleButton);
          } else {
            var select = document.createElement('select');
            select.className = 'recommended-variant-select';
            select.setAttribute('aria-label', product.title);

            product.variants.forEach(function (variant) {
              var option = document.createElement('option');
              option.value = variant.id;
              option.textContent = variant.title;
              select.appendChild(option);
            });

            var multiButton = document.createElement('button');
            multiButton.type = 'button';
            multiButton.className = 'button button--sm button--subdued upsell-action';
            multiButton.setAttribute('data-variant-select', '');
            multiButton.textContent = '+ Add';

            card.appendChild(select);
            card.appendChild(multiButton);
          }

          recommendationsContainer.appendChild(card);
        });
      })
      .catch(function (error) {
        console.error('Error fetching product recommendations:', error);
      });
  }

  function syncRecommendationsPanelHeight(cartDrawer) {
    var panel = cartDrawer && cartDrawer.querySelector('.cart-drawer-recommendations');

    if (!panel) {
      return;
    }

    if (window.matchMedia('(max-width: 767px)').matches) {
      panel.style.removeProperty('height');
      cartDrawer.style.removeProperty('--cart-drawer-panel-height');
      return;
    }

    var content = cartDrawer.shadowRoot && cartDrawer.shadowRoot.querySelector('[part="content"]');

    if (!content) {
      return;
    }

    panel.style.height = content.offsetHeight + 'px';
    cartDrawer.style.setProperty('--cart-drawer-panel-height', content.offsetHeight + 'px');
  }

  function observeRecommendationsPanelHeight(cartDrawer) {
    if (!cartDrawer || cartDrawer.hasAttribute('data-panel-height-sync')) {
      return;
    }

    cartDrawer.setAttribute('data-panel-height-sync', '');

    var content = cartDrawer.shadowRoot && cartDrawer.shadowRoot.querySelector('[part="content"]');

    if (typeof ResizeObserver !== 'undefined' && content) {
      var resizeObserver = new ResizeObserver(function () {
        syncRecommendationsPanelHeight(cartDrawer);
      });
      resizeObserver.observe(content);
    }

    cartDrawer.addEventListener('dialog:after-show', function () {
      requestAnimationFrame(function () {
        syncRecommendationsPanelHeight(cartDrawer);
      });
    });

    window.addEventListener('resize', function () {
      syncRecommendationsPanelHeight(cartDrawer);
    });
  }

  function initFreeShippingBar(cartDrawer) {
    var freeShippingBar = cartDrawer.querySelector('free-shipping-bar');
    var progressBar = cartDrawer.querySelector('.free-shipping-bar .progress-bar');

    if (!freeShippingBar) {
      return;
    }

    var totalPrice = freeShippingBar.getAttribute('total-price');

    if (totalPrice !== null) {
      freeShippingBar.setAttribute('total-price', totalPrice);
    }

    if (!progressBar) {
      return;
    }

    var threshold = parseFloat(freeShippingBar.getAttribute('threshold'));
    var total = parseFloat(freeShippingBar.getAttribute('total-price'));

    if (threshold < 1000) {
      threshold = threshold * 100;
    }

    var progress = threshold > 0 ? Math.min(total / threshold, 1) : 0;

    progressBar.setAttribute('aria-valuenow', Math.round(total));
    progressBar.setAttribute('aria-valuemax', Math.round(threshold));
    progressBar.style.setProperty('--progress', progress);
  }

  function initCartDrawer(cartDrawer) {
    if (!cartDrawer) {
      return;
    }

    loadDynamicRecommendations(cartDrawer);
    observeRecommendationsPanelHeight(cartDrawer);
    syncRecommendationsPanelHeight(cartDrawer);
    initFreeShippingBar(cartDrawer);
  }

  document.addEventListener('cart-drawer:refreshed', function (event) {
    initCartDrawer(event.target);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var cartDrawer = document.getElementById('cart-drawer');

    if (!cartDrawer) {
      return;
    }

    customElements.whenDefined('cart-drawer').then(function () {
      requestAnimationFrame(function () {
        initCartDrawer(cartDrawer);
      });
    });
  });
})();
